<!--
  - Copyright (c) 2024. Haodong JU
  -->

<template>
  <v-select
    :menu-props="{offsetY:true}"
    item-value="start"
    v-model="internalValue"
    item-text="start"
    :items="timeArrays"
    :dense="dense"
    :hide-details="hideDetails"
    :label="$t(label)"
    :rules="rules"
    outlined
  />
</template>

<script>
import { timeArrays } from '@/model/dataLayer/api/common/OpenTimeList'

export default {
  name: 'TimeSelector',
  props: {
    value: {},
    dense: {},
    hideDetails: {},
    label: {},
    rules: {
      type: Array,
      default: () => []
    }
  },
  data: function () {
    return {
      internalValue: null
    }
  },
  watch: {
    value: {
      immediate: true,
      handler () {
        this.internalValue = this.value
      }
    },
    internalValue () {
      this.$emit('input', this.internalValue)
    }
  },
  computed: {
    timeArrays () {
      return timeArrays
    }

  }

}
</script>

<style scoped>

</style>
